import {
  CONTENT_WIDTH,
  bottomMarginItemGlobal
} from "../../utils/pdfConstants";

// src/components/report/blocksPdf/ymparistoBlock.js

export function renderYmparistoBlock({ contentWidth = CONTENT_WIDTH,
  block,
  content = [],
  rakennusData,
  fontSize = 10
} = {}) {
  if (!content) {
    throw new Error("content is required");
  }

  const buildings = rakennusData?.rakennukset_fulls || [];
  const smallFontSize = fontSize * 0.85;

  const GREEN = "#04aa00";
  const LIGHT_GREY = "#f0f0f0";
  const WHITE = "#ffffff";

  const renderCellValue = value => {
    if (
      value === null ||
      value === undefined ||
      value === ""
    ) {
      return "–";
    }

    return String(value);
  };

  const createCell = (
    text,
    {
      bold = false,
      color = "black",
      fillColor,
      alignment = "left",
      margin = [0, 0, 0, 0],
      noWrap = false
    } = {}
  ) => ({
    text: renderCellValue(text),
    bold,
    color,
    fillColor,
    alignment,
    margin,
    noWrap,
    font: "Lato",
    fontSize: smallFontSize
  });

  const createTableLayout = () => ({
    hLineWidth: () => 0,
    vLineWidth: () => 0,
    hLineColor: () => "#bbb",
    vLineColor: () => "#bbb",
    paddingLeft: () => 4,
    paddingRight: () => 4,
    paddingTop: () => 4,
    paddingBottom: () => 4,
    dontBreakRows: false
  });

  /**
   * Creates a table matching renderTekniikkatauluBlock.
   *
   * rows:
   * [
   *   { label: "...", value: "..." },
   *   ...
   * ]
   */
const pushEnvironmentTable = ({
  title,
  valueHeader = "Tiedot",
  rows = [],
  emptyText,
  singleHeader = false,
  alternateRows = false
}) => {
  const TABLE_WIDTH = contentWidth * 0.92;

  const body = [
    singleHeader
      ? [
          {
            ...createCell(title, {
              bold: true,
              color: WHITE,
              fillColor: GREEN
            }),
            colSpan: 2
          },
          {}
        ]
      : [
          createCell(title, {
            bold: true,
            color: WHITE,
            fillColor: GREEN
          }),
          createCell(valueHeader, {
            bold: true,
            color: WHITE,
            fillColor: GREEN,
            alignment: "left"
          })
        ]
  ];

  if (rows.length === 0) {
    body.push([
      {
        ...createCell(emptyText || "Ei tietoja saatavilla.", {
          fillColor: LIGHT_GREY
        }),
        colSpan: 2
      },
      {}
    ]);
  } else {
rows.forEach(({
  label,
  value,
  isSection = false,
  fullWidth = false,
  whiteBackground = false
}, index) => {
  if (isSection) {
    body.push([
      {
        ...createCell(label, {
          bold: true,
          fillColor: LIGHT_GREY
        }),
        colSpan: 2
      },
      {}
    ]);

    return;
  }

  if (fullWidth) {
    body.push([
      {
        ...createCell(label),
        colSpan: 2
      },
      {}
    ]);

    return;
  }

  const rowFillColor = alternateRows
    ? index % 2 === 0
      ? LIGHT_GREY
      : WHITE
    : whiteBackground
      ? WHITE
      : undefined;

  body.push([
    createCell(label, {
      fillColor: rowFillColor
    }),
    createCell(value, {
      fillColor: rowFillColor
    })
  ]);
});

  }

   content.push({
    stack: [
      {
        table: {
          widths: [
            TABLE_WIDTH * 0.47,
            TABLE_WIDTH * 0.58
          ],
          body
        },
        layout: createTableLayout()
      }
    ],
    margin: [0, bottomMarginItemGlobal, 0, 0]
  });
};

  if (buildings.length === 0) {
    content.push({
      text: "Ei ympäristötietoja saatavilla.",
      style: "paragraph",
      margin: [0, 5, 0, bottomMarginItemGlobal]
    });

    return;
  }

  // ---------------------------------------------------------------------------
  // Pohjavesialueet
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
// Pohjavesi- ja tulvariskialueet
// ---------------------------------------------------------------------------

const allPohjavesi = buildings.flatMap(
  building => building.aluetiedot?.pohjavesi || []
);

const uniquePohjavesi = [];
const seenPohjavesi = new Set();

allPohjavesi.forEach(item => {
  const key = [
    item.nimi || "",
    item.luokka || "",
    item.etäisyys || ""
  ].join("|");

  if (!seenPohjavesi.has(key)) {
    seenPohjavesi.add(key);
    uniquePohjavesi.push(item);
  }
});

const allTulva = buildings.flatMap(
  building => building.aluetiedot?.tulvariski || []
);

const uniqueTulva = [];
const seenTulva = new Set();

allTulva.forEach(item => {
  const key = [
    item.lähde || "",
    item.nimi || ""
  ].join("|");

  if (!seenTulva.has(key)) {
    seenTulva.add(key);
    uniqueTulva.push(item);
  }
});

// Render only after both arrays have been created
pushEnvironmentTable({
  title: "Pohjavesi- ja tulvariskialueet",
  singleHeader: true,
  rows: [
    {
      label: "Pohjavesialueet",
      isSection: true
    },

    ...(uniquePohjavesi.length === 0
      ? [
          {
            label: "Kohde ei sijaitse pohjavesialueella.",
            fullWidth: true
          }
        ]
      : uniquePohjavesi.flatMap((item, index) => {
          const rows = [];

          if (uniquePohjavesi.length > 1) {
            rows.push({
              label: `Pohjavesialue ${index + 1}`,
              isSection: true
            });
          }

          rows.push({
  label: "Nimi",
  value: item.nimi,
  whiteBackground: true
});

if (item.luokka) {
  rows.push({
    label: "Luokka",
    value: item.luokka,
    whiteBackground: true
  });
}

if (item.etäisyys) {
  rows.push({
    label: "Etäisyys",
    value: item.etäisyys,
    whiteBackground: true
  });
}
          return rows;
        })),

    {
      label: "Tulvariskialueet",
      isSection: true
    },

    ...(uniqueTulva.length === 0
      ? [
          {
            label: "Kohde ei sijaitse tulvariskialueella.",
            fullWidth: true
          }
        ]
      : uniqueTulva.flatMap((item, index) => {
          const rows = [];

          if (uniqueTulva.length > 1) {
            rows.push({
              label: `Tulvariskialue ${index + 1}`,
              isSection: true
            });
          }

          rows.push({
            label: "Nimi",
            value: item.nimi
          });

          if (item.lähde) {
            rows.push({
              label: "Lähde",
              value: item.lähde
            });
          }

          return rows;
        }))
  ]
});

  // ---------------------------------------------------------------------------
  // Radon
  // ---------------------------------------------------------------------------

  const firstBuilding = buildings[0] || {};
  const radon = firstBuilding.aluetiedot?.radon || null;

  const postinumero =
    radon?.postinumero ??
    firstBuilding.postinumero ??
    "–";

  const alue =
    radon?.postitoimipaikka ??
    firstBuilding.toimipaikka ??
    "–";

  const radonRows = [
    {
      label: "Postinumero",
      value: postinumero
    },
    {
      label: "Alue",
      value: alue
    }
  ];

  if (radon) {
    radonRows.push(
      {
        label: "Mitattuja pientaloasuntoja",
        value: radon.mitattujaAS
      },
      {
        label: "Keskimääräinen radon",
        value:
          radon.keskiarvo !== null &&
          radon.keskiarvo !== undefined
            ? `${radon.keskiarvo} Bq/m³`
            : "–"
      },
      {
        label: "Mediaani",
        value:
          radon.mediaani !== null &&
          radon.mediaani !== undefined
            ? `${radon.mediaani} Bq/m³`
            : "–"
      },
      {
        label: "200 Bq/m³ ylitykset",
        value:
          radon.yli200 !== null &&
          radon.yli200 !== undefined
            ? `${radon.yli200} %`
            : "–"
      },
      {
        label: "300 Bq/m³ ylitykset",
        value:
          radon.yli300 !== null &&
          radon.yli300 !== undefined
            ? `${radon.yli300} %`
            : "–"
      },
      {
        label: "1000 Bq/m³ ylitykset",
        value:
          radon.yli1000 !== null &&
          radon.yli1000 !== undefined
            ? `${radon.yli1000} %`
            : "–"
      }
    );
  } else {
    radonRows.push({
      label: "Mittaustiedot",
      value: "Ei mitattuja radonarvoja alueella."
    });
  }

pushEnvironmentTable({
  title: "Radon",
  valueHeader: "Arvo",
  rows: radonRows,
  alternateRows: true
});

  content.push({
    text: "",
    margin: [0, 0, 0, bottomMarginItemGlobal]
  });
}